import { Button } from "@fluentui/react-components";
import { DocumentTableRegular } from "@fluentui/react-icons";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import React from "react";
import { useTranslation } from "react-i18next";
import { useClientBalancePageStoreState } from "store/ClientBalancePageStore";

type Props = {
  refExcelExport: ExcelExport;
  /** data-help anchor for the in-app page guide (see help/README.md). */
  dataHelp?: string;
};

export const ExportExcelButton = ({ refExcelExport, dataHelp }: Props) => {
  const { t } = useTranslation();
  const { clientBalancesLoadStatus } = useClientBalancePageStoreState();

  return (
    <Button
      data-help={dataHelp}
      appearance="subtle"
      icon={<DocumentTableRegular fontSize={24} />}
      disabled={clientBalancesLoadStatus === "loading"}
      onClick={() => {
        refExcelExport?.save();
      }}
    >
      {t("greco.exportExcel")}
    </Button>
  );
};
